export default __webpack_public_path__ + "static/banner-f502cd7024410a16b6ca3bb1d0e03958.jpg";